<template>
  <div class="d-flex flex-wrap mt-2">
    <div
      v-for="d in items"
      :key="d.key"
      class="d-flex align-center ml-4"
      :style="{ opacity: isItemOpaque(d.key) ? 0.3 : 1 }"
      @mouseenter="$emit('enter-item', d)"
      @mouseleave="$emit('leave-item', d)"
    >
      <div
        style="width:16px; height:16px;"
        :style="{ background: d.color }"
        class="mr-2"
      ></div>
      <div>{{ d.value }} ({{ $t(`data.${d.type}`) }})</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },
    isItemOpaque: {
      type: Function,
      required: true
    }
  }
};
</script>
